<template>
  <div>
    <el-collapse-transition>
      <div v-show="isShow" class="right_fix">
        <div class="close flex f_jc_e f_ac_c" @click="onClose()">
          <el-image
            :src="require('@/assets/image/page_image/home/close.svg')"
          ></el-image>
        </div>
        <div class="right_fix_item1">
          <el-image
            :src="require('@/assets/image/page_image/home/2_person.png')"
          ></el-image>
          <div class="right_fix_item1_line1 flex f_ai_c cr_fff">
            <el-image
              class="mr4"
              :src="require('@/assets/image/page_image/home/phone.svg')"
            ></el-image>
            <div class="fsr009">咨询热线</div>
          </div>
          <div class="right_fix_item1_line2 cr_fff fsr009 fw500">
            400-7777-557
          </div>
        </div>
        <div class="right_fix_item2 mt10">
          <el-image
            :src="require('@/assets/image/page_image/home/2_code.png')"
          ></el-image>
          <div class="fsr009">微信扫码咨询</div>
        </div>
        <div class="right_fix_item3 side_top mt10" @click="openWebsite">
          <el-image :src="require('@/assets/image/home.svg')"></el-image>
          <div>官方网站</div>
        </div>
        <div
          v-show="showBackToTop"
          class="right_fix_item3 side_top mt10"
          @click="goTop"
        >
          <el-image :src="require('@/assets/image/top.svg')"></el-image>
          <div>返回顶部</div>
        </div>
      </div>
    </el-collapse-transition>
    <el-collapse-transition>
      <div v-show="!isShow" class="side_icon">
        <el-image
          @click="onClose()"
          :src="require('@/assets/image/kf.svg')"
        ></el-image>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import { CollapseTransition } from "element-ui";
export default {
  components: {
    "el-collapse-transition": CollapseTransition,
  },
  data() {
    return {
      isShow: true,
      showBackToTop: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    onClose() {
      this.isShow = !this.isShow;
    },
    goTop() {
      scrollTo(0, 0);
    },
    handleScroll() {
      // Calculate the scroll position
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // Update the showBackToTop data property
      this.showBackToTop = scrollTop > 100;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    openWebsite() {
      // window.location.href = "https://wonsun.com.cn";
      window.open("https://wonsun.com.cn");
    },
  },
};
</script>

<style lang="scss" scoped>
.right_fix {
  width: 149px;
  height: 392px;
  position: fixed;
  right: 18px;
  top: 30%;
  z-index: 999;
  .close {
    cursor: pointer;
    width: 100%;
    .el-image {
      width: 18px;
      height: 18px;
    }
  }
  .right_fix_item1 {
    width: 149px;
    height: 183px;
    margin-top: 9px;
    position: relative;
    .right_fix_item1_line1 {
      position: absolute;
      top: 130px;
      left: 0;
      width: 100%;

      @include flex_ct();
      .el-image {
        width: 16px;
        height: 16px;
      }
    }
    .right_fix_item1_line2 {
      position: absolute;
      top: 155px;
      left: 0;
      width: 100%;
      @include flex_ct();
    }
  }
  .right_fix_item2 {
    width: 149px;
    padding: 12px 0;
    background: #fff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    text-align: center;
    .el-image {
      width: 95px;
      height: 95px;
    }
    div {
      color: var(--Gray-3, #828282);
      font-family: Source Han Sans CN;
      font-size: 20px;
      font-style: normal;
      font-weight: 350;
      line-height: normal;
    }
  }
  .right_fix_item3 {
    width: 149px;
    height: 40px;
    cursor: pointer;
  }
}
.side_top {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  .el-image {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }
  div {
    color: #333;
    font-family: Source Han Sans CN;
    font-size: 18px;
    font-style: normal;
    font-weight: 350;
    line-height: normal;
  }
}
.side_icon {
  position: fixed;
  right: 14px;
  bottom: 5%;
  cursor: pointer;
  z-index: 999;
}
</style>